window.hostUrl = ''
window.alefMessagingPagesUrl = `${window.location.pathname}alefMessagingPages`
window.marketplaceFrontendUrl = `${window.location.pathname}marketplaceFrontend`
window.teacherActivitiesForStudentsUrl = `${window.location.pathname}teacherActivitiesForStudents`
window.alefMlTutoraiUiUrl = `${window.location.pathname}alefMlTutoraiUi`
window.alefMlExamPracticeUiUrl = `${window.location.pathname}alefMlExamPracticeUi`
window.ebookPlayerUrl = `${window.location.pathname}ebook-app-mfe`
window.studentAssessmentTestFrontendUrl = `${window.location.pathname}alef-student-test-frontend`
import('./bootstrap')
